import React from "react";

import { Text } from "@performyard/py-components";

import { AdminContainer, AdminTitle } from "../../../../components/Admin";
import { Grid, GridCol } from "../../../../components/Grid";
import Toggle from "../../../../components/Inputs/ToggleSwitches/ThumbSwitch";
import PageTitle from "../../../../components/PageTitle";
import Spacer from "../../../../components/Spacer";

import {
	useCompanyCalendarIntegrationSettings,
	useUpdateCompanyCalendarIntegrationSettings,
} from "../../../../api/hooks";
import { useFeatureFlagQuery } from "../../../../hooks/useFeatureFlag";

import ErrorPage from "../../../Error";

const CalendarIntegration = () => {
	const { value: calendarIntegrationFeatureVisible } = useFeatureFlagQuery(
		"ff-is-calendar-integration-enabled",
		false
	);

	const { data: calendarIntegrationSettings } = useCompanyCalendarIntegrationSettings({
		enabled: calendarIntegrationFeatureVisible,
	});
	const { mutate: updateCalendarIntegrationSettings, isPending } = useUpdateCompanyCalendarIntegrationSettings();

	if (!calendarIntegrationFeatureVisible) {
		return <ErrorPage code={404} />;
	}

	return (
		<AdminContainer>
			<PageTitle title="Calendar Integration" />
			<AdminTitle>Calendar Integration</AdminTitle>
			<Spacer height={4} />
			<Grid cols={10} gap={2}>
				<GridCol span={4}>
					<Text size="paragraph-2" weight="semi-bold" color="neutral-9">
						Calendar Integration Settings
					</Text>
					<Spacer height={1} />
					<Text size="paragraph-3" weight="regular" color="neutral-9">
						Control whether or not the members of your organization can link their work calendar in
						PerformYard.
					</Text>
				</GridCol>
				<GridCol span={1} />
				<GridCol span={5}>
					<div className="flex w-full items-start justify-between space-x-2">
						<div>
							<Text size="paragraph-2" weight="semi-bold" color="neutral-9">
								Enable Calendar Integration
							</Text>
							<Spacer height={1} />
							<Text size="paragraph-3" weight="regular" color="neutral-9">
								Disabling this setting will hide the Calendar Integration from users of the application.
							</Text>
						</div>
						<Toggle
							onChange={() => {
								updateCalendarIntegrationSettings({ enabled: !calendarIntegrationSettings?.enabled });
							}}
							value={calendarIntegrationSettings?.enabled || false}
							isLoading={isPending}
						/>
					</div>
				</GridCol>
			</Grid>
		</AdminContainer>
	);
};

export default CalendarIntegration;
